import httpRequest from '../../common/lib/http-request';

// *******************
// BRAIN ANSWER SERVICES
// *******************

function getBrainAnswerAccessUrl(associateId) {
    return httpRequest({
        url: '/Associate/brain-answer/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_API_URL);
}

const BrainAnswerService = { getBrainAnswerAccessUrl }

export default BrainAnswerService;